export const nilList = [undefined, 'undefined', null, 'null'];

export const CAMPAIGN_TYPES = {
  all: 0,
  adminFee: 1,
  marketingMsg: 2,
  earningRate: 3,
};
